import Form from './Form';
export type { FormProps } from './Form.types';

export default Form;
